import { render, staticRenderFns } from "./CaseKeywords.vue?vue&type=template&id=c83b6068"
import script from "./CaseKeywords.vue?vue&type=script&lang=js"
export * from "./CaseKeywords.vue?vue&type=script&lang=js"
import style0 from "./CaseKeywords.vue?vue&type=style&index=0&id=c83b6068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports